module.exports = __webpack_public_path__ + "static/media/sustainability-2.66970fd1.png";